require('../userProfileService');

"use strict";

angular.module('app.userProfile.userProfileDirective.userProfileDirectiveController', [
  'app.userProfile.userProfileService'
])
  .controller('app.userProfile.userProfileDirective.userProfileDirectiveController', [
    '$scope',
    'app.userProfile.userProfileService',
    'DEFAULT_PROFILE_IMAGE',
    function ($scope, userProfile, DEFAULT_PROFILE_IMAGE) {
      $scope.username = $scope.username || null;
      $scope.profile = null;
      $scope.default_profile_image = DEFAULT_PROFILE_IMAGE;

      $scope.games_watched_count = function () {
        let count;
        if ($scope.profile) {
          count = $scope.profile.live_watched_count + $scope.profile.archived_watched_count;
        } else {
          count = 0;
        }
        if (isNaN(count)) {
          count = 0;
        }
        return count;
      };

      $scope.toggle_follow = function () {
        userProfile.toggleFollow($scope.profile);
      };

      let init = function () {
        let promise;
        promise = userProfile.retrieve($scope.username);
        if (promise) {
          return promise
            .then((response) => {
              let data = response.data;

              if (data.user) {
                return $scope.profile = data.user;
              }
            });
        }
      };

      return init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/userProfile/userProfileDirective/userProfileDirectiveController.js